import Wrapper from '../components/global/Wrapper';

const PaymentCustomers = () => {
  return (
    <Wrapper className=' space-y-3 pt-[12px] md:pt-12 md:space-y-8  !mr-0'>
      PaymentCustomers
    </Wrapper>
  );
};

export default PaymentCustomers;
